import { SVGProps } from 'react';

export const IconCrossedTools = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 30 29' {...props}>
      <g stroke='currentColor' strokeWidth='2' fill='none' fillRule='evenodd'>
        <path d='m23.27 1.268-3.005 3.11 4.809 4.802 2.632-2.629-1.832 3.17c-.197.34-.47.622-.788.83l-.163.097c-.39.212-.836.32-1.296.299l-2.235-.104L5.207 26.998c-.928-.117-1.455-.547-1.852-.944-.396-.395-.827-.92-.977-1.44l16.21-16.552-.073-2.397a2.453 2.453 0 0 1 1.157-2.158l3.598-2.239zM21.888 17.804l4.97 4.916c.26.258.162.722.079 1.13-.161.785-.576 1.618-1.022 2.064-.448.447-1.283.861-2.071 1.022-.41.084-.874.181-1.137-.08l-4.965-4.911 4.146-4.141zM3.42 1.209l3.718.928.554 3.134 5.432 5.421-2.514 2.512-5.406-5.397-2.984-.744-1.088-3.568L3.42 1.209z' />
        <path d='m18.008 15.16 2.794 2.79-2.718 2.715-2.794-2.79 2.718-2.715z' />
      </g>
    </svg>
  );
};
